module.exports = "/_next/static/pages/test-guidelines/af1daf819aadb5db857a6da63c914ef8.png";